import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

// MUI Components
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

const IllegalPluginModal = ({ plugin, setPlugin, clearPlugin }) => {

    const [ open, setOpen ]         = useState(false);
    const [ title, setTitle ]       = useState('Add Plugin');

    const savePlugin = () => {
        axios.post('/restricted-plugin/save', plugin).then(response => {
            if( response.data.success ){
                toast.success('Plugin saved successfully');
            }
            else{
                toast.error(response.data.message);
            }
            clearPlugin();
        });
    }

    useEffect(() => {
        if( plugin.id ){
            setOpen(true);
            setTitle( plugin.id == 'new' ? 'Add Plugin' : 'Edit Plugin');
        }
        else{
            setOpen(false);
        }
    }, [plugin.id]);

    return (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth='sm' fullWidth className='illegal-plugin-modal'>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Box className='form'>
                    <TextField label='Name' value={plugin.name} onChange={(e) => setPlugin({ ...plugin, name: e.target.value })} />
                    <br/>
                    <TextField label='Slug' value={plugin.slug} onChange={(e) => setPlugin({ ...plugin, slug: e.target.value })} />
                    <br/>
                    <TextField label='Reason' value={plugin.reason} onChange={(e) => setPlugin({ ...plugin, reason: e.target.value })} multiline={true} minRows={5} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color='error' onClick={() => setOpen(false)}>Cancel</Button>
                <Button variant='contained' color='primary' onClick={savePlugin}>Save</Button>
            </DialogActions>
        </Dialog>
    );

}

export default IllegalPluginModal;